<div class="tutorial-video-dialog">
  <div #videoWrapper
       class="video-wrapper"
       [class.controls-visible]="controlsVisible"
       (touchstart)="onTouch()">
    <button class="overlay-btn close-btn" mat-icon-button (click)="closeAndSave()" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>

    <button
      *ngIf="pipSupported"
      class="overlay-btn pip-btn"
      mat-icon-button
      (click)="togglePip()"
      [title]="isPipActive ? 'Sair do Picture-in-Picture' : 'Picture-in-Picture'"
      [attr.aria-label]="isPipActive ? 'Sair do Picture-in-Picture' : 'Picture-in-Picture'"
    >
      <mat-icon>{{ isPipActive ? 'picture_in_picture_alt' : 'picture_in_picture' }}</mat-icon>
    </button>

    <!-- O elemento <video> persistente é injetado aqui pelo TutorialVideoService -->
    <div #videoHost class="video-host"></div>
  </div>
</div>
